module.exports = __webpack_public_path__ + "static/media/terra2.efa49424.jpeg";